import React, { useState, useEffect } from "react";
import { View, StyleSheet, Platform } from "react-native";

import CloseIcon from "../../common/dialog/CloseIcon";
import ManaButton from "../../common/ManaButton";
import cardStyles from "./cardStyles";
import Goal from "../../resolution/goals/Goal";
import ElementsHelper from "../../elements/ElementsHelper";
import CardUtils from "./CardUtils";
import appStyles from "../../../appStyles";
import appPages from "../../../../appPages";
import { navigate } from "../../../../helpers/utils";

export default function ScheduleTimeCard({
  controller,
  data,
  isSnoozed = false,
  onSnooze = () => {},
}) {
  const [showCard, setShowCard] = useState(true);
  const cardUtils = new CardUtils(controller, data, setShowCard);
  // ------------------------------------- METHODS -------------------------------------

  useEffect(() => {
    cardUtils.restoreCard(data.stored_data);
  }, []);

  //const element = ElementsHelper.findById(controller, data.gem_target_id);
  const element = controller.state.elements[0];

  const remindMeLater = () => {};
  const scheduleTime = () => {
    navigate(controller, appPages.scheduleTimePage, "changepage", { id_element: element?.id });
  };

  const goal = {
    target_name: element?.name,
    target_emoji: data.icon || element.icon,
    hours: data.tracked || 2,
    target_hours: data.target || 7,
    time_unit: data.goal_time_unit || "week",
    total_pct: Math.max(Math.min(Math.abs(data.total_pct), 1), 0) || 0.2,
    target_achieved: 1,
    achieved_pct: 1,
    mood: 5,
    text: "Keep it up! Spend some more time on this to hit your goal!",
  };

  return !isSnoozed && !showCard ? null : (
    <View style={cardStyles.container}>
      <View style={[cardStyles.card, { minHeight: 160 }]}>
        <CloseIcon
          onPress={(e) => onSnooze(cardUtils, e)}
          style={cardStyles.closeButton}
        />

        <View style={{ width: "100%" }}>
          <Goal style={cardStyles.goal} controller={controller} goal={goal} />
          <View style={cardStyles.separator} />

          <View style={appStyles.horizontalButtons}>
            <ManaButton
              onPress={remindMeLater}
              text={"Remind me later"}
              style={[styles.button, { marginRight: 6 }]}
              styleText={[styles.buttonText]}
            />

            <ManaButton
              isMainButton
              onPress={scheduleTime}
              text="Schedule time"
              style={[styles.button]}
              styleText={[styles.buttonText]}
            />
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  button: {
    width: "auto",
    paddingHorizontal: 10,
    borderRadius: 6,
    width: "50%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
  },
});
